<template>
  <div class="search-input">
    <label v-if="label">{{label}}</label>
    <v-form :schema="schema" @change="onChange($event)" @success="onSubmit($event)" :recaptcha="false">
      <button v-if="!loading && active" class="search-input__button" slot="footer" @click.prevent="clear()">
        <i class="icon-close"></i>
      </button>
      <button v-else :disabled="loading" class="search-input__button" slot="footer">
        <img v-if="loading" src="@/assets/img/loader.svg" alt="Carregando" />
        <i v-else class="icon-magnifyingGlass" alt="Buscar"></i>
      </button>
    </v-form>
  </div>
</template>

<script>
import Vue from 'vue';
import Form from '@/components/uikit/form/Form.vue';

export default {
  name: 'SearchInput',
  components: {
    'v-form': Form,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Digite aqui para buscar',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active: false,
      lastSearch: '',
      schema: [
        {
          type: 'text',
          name: 'search',
          id: 'searchInput',
          value: '',
          placeholder: this.placeholder,
          focus: () => this.onFocus(),
          validations: this.required ? { required: true } : null,
        },
      ],
    };
  },
  methods: {
    onSubmit(form) {
      this.lastSearch = form.search;
      this.$emit('search', form.search);
      this.active = true;
    },
    onFocus() {
      this.$emit('focus');
    },
    onChange(field) {
      if (field.value == this.lastSearch) {
        return;
      }
      this.active = false;
    },
    clear() {
      this.active = false;
      this.$el.querySelector('form').reset();
      this.$emit('clear');
    },
  },
};
</script>

<style lang="scss" scoped>
$component: '.search-input';
#{$component} {
  overflow: hidden;
  label {
    display: inline-block;
    margin-left: $gutter-l;
    margin-bottom: $gutter;
    font-family: inherit;
    font-weight: $font-weight-heavy;
    font-size: $font-size-l;
    color: $color-sys-e;
  }
  .form {
    display: grid;
    grid-template-columns: auto $input-height * 2;
    grid-template-rows: $input-height;
    /deep/ .form-field {
      grid-column: 1 / 3;
      grid-row: 1;
      margin: 0;
      input {
        padding-right: $input-height + $gutter-l;
        background-color: white;
      }
    }
    /deep/ .form__footer {
      z-index: 2;
      grid-column: 2 / 3;
      grid-row: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  &__button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: $input-height;
    border-top-right-radius: $gutter-xl;
    border-bottom-right-radius: $gutter-xl;
    cursor: pointer;
    border: none;
    background-color: transparent;
    outline: none;
    i {
      color: $color-sys-e;
      transition: opacity $transition-duration $transition-timing-function;
      &.icon-close {
        font-size: $font-size-xs;
      }
      &.icon-magnifyingGlass {
        font-size: $font-size-xl;
      }
    }
    img {
      width: $gutter-xxl;
    }
    &:hover i {
      opacity: 0.6;
    }
  }
}

</style>
